import { type FileUploadFragment, useUpdateFileUploadTagsMutation } from "@qw/graphql";
import { Button, cn, Icon, type MaterialSymbol, useToast } from "@qw/ui";
import type { FC } from "react";

export interface FileLabelToggleProps {
  file: FileUploadFragment & { labels: Array<{ label: string }> };
  label: string;
  icon?: MaterialSymbol;
  activeClassName?: string;
}

export const FileLabelToggle: FC<FileLabelToggleProps> = ({
  file,
  label,
  icon = "flag",
  activeClassName = "filled text-destructive",
}) => {
  const { toast } = useToast();
  const [updateLabel, { loading }] = useUpdateFileUploadTagsMutation();

  const isActive = file.labels.some((l) => l.label === label);

  const handleToggle = async () => {
    await updateLabel({
      variables: { input: { id: file.id, label } },
      onError: (e) => toast({ title: e.message }),
      onCompleted: () => {
        toast({ title: `Label ${isActive ? "removed" : "added"}` });
      },
      refetchQueries: ["FilesByInsured", "FilesByLabel", "FileTags"],
    });
  };

  return (
    <Button variant="ghost" size="xs" display="icon" onClick={handleToggle} disabled={loading}>
      <Icon icon={icon} className={cn(isActive && activeClassName)} />
    </Button>
  );
};
